import { Component, OnInit } from '@angular/core';
import { StoreService } from '../../services/store-service/store.service';
import { UserService } from '../../services/user-service/user.service';

@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  constructor(
    public storeService: StoreService,
    private userService: UserService,
  ) {}

  async ngOnInit(): Promise<void> {
    await this.userService.getUserDetail();
  }
}
